import styled from "styled-components";
import {color} from "../../styles";

export const TitleWrapper = styled.div`
    width: 100%;
    height: 36px;
    display: flex;
    justify-content: space-between;

     @media (max-width: 768px) {
        flex-direction: column;
        gap: 8px;
        align-items: flex-start;
    }
`;

export const TitleText = styled.div`
    font-size: 28px;
    font-weight: 700;
    line-height: 36px;
    word-wrap: break-word;
    align-content: space-around;
    color: ${color.secondary.CHARCOAL};
    margin: 0;
    @media (max-width: 1024px) {
        font-size: 20px;
    }

    @media (max-width: 768px) {
        font-size: 18px;
    }

    @media (max-width: 480px) {
        font-size: 16px;
    }
`;

export const StyleButtonWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 8px;
`;

export const ActionsContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  gap: 12px;
  ${props => props.isMobile && `
    width: 100%;
    flex-direction: column;
  `}
`;